export default {
	'profile.actions.companyadd.url': '/account',
	'profile.actions.coWebsite.url': '/account',
	'profile.actions.coName.url': '/account',
	'profile.actions.lane3.url': '/profile-edit/lanes',
	'profile.actions.travel.url': '/profile-edit/rates_locations',
	'profile.actions.tests.url': '/lms/view',
	'profile.actions.tax.url': '/account/tax',
	'profile.actions.education.url': '/profile-edit/education',
	'profile.actions.languages.url': '/profile-edit/languages',
	'profile.actions.bank.url': '/funds',
	'profile.actions.licenses.url': '/profile-edit/licenses',
	'profile.actions.personaladd.url': '/profile-edit',
	'profile.actions.zipCodes.url': '/profile-edit/rates_locations',
	'profile.actions.background.url': '/screening/bkgrnd',
	'profile.actions.drugTest.url': '/screening/drug',
	'profile.actions.insurance.url': '/profile-edit/insurance',
	'profile.actions.tags.url': '/profile-edit/specialties',
	'profile.actions.resume.url': '/profile-edit/employment#resume',
	'profile.actions.coLogo.url': '/account',
	'profile.actions.coOverview.url': '/account',
	'profile.actions.certifications.url': '/profile-edit/certifications',
	'profile.actions.hrRate.url': '/profile-edit/rates_locations',
	'profile.actions.employment.url': '/profile-edit/employment',
	'profile.actions.hours.url': '/mysettings/hours',
	'profile.actions.photo.url': '/profile-edit/photo',
	'profile.actions.skills.url': '/profile-edit/skills',
	'profile.actions.linkedin.url': '/profile-edit/employment',
	'profile.addMessage': 'Please add a message.',
	'profile.addToNetwork': 'Add to Network',
	'profile.blockWorker': 'Block a Worker',
	'profile.deleteComment': 'Delete Comment',
	'profile.deleteThisComment': 'Are you sure you want to delete this comment?',
	'profile.edit': 'edit',
	'profile.featurePhotoAndVideos': 'We allow you to feature up to 10 photos/videos on your profile. Please remove one to add more.',
	'profile.list_me_in_search': 'List me in search',
	'profile.new': 'NEW',
	'profile.profile_is_listed': 'Your profile is listed in search results.',
	'profile.profile_is_pending': 'Your profile is pending approval for search listing. You will be notified when you are listed in search results or if profile changes are required.',
	'profile.profile_to_do': 'Profile To Do',
	'profile.promote_your_profile': 'Promote Your Profile in Search Results',
	'profile.removeFromNetwork': 'Remove from Network',
	'profile.reportConcern': 'Report a Concern',
	'profile.reviewMedia': 'Review Media',
	'profile.seeking_from_others': 'Professionals who are part of an extended workforce and are seeking assignments from other companies using WorkMarket must opt in to be listed in the global WorkMarket search results. Search results include independent contractors, temporary workers, professional consultants and other non-employees.',
	'profile.selectOneOrMore': 'Select one or multiple Tests',
	'profile.selectedTests': 'Success, the worker was invited to the selected tests.',
	'profile.showLess': 'Show less',
	'profile.showTests': 'Show more tests',
	'profile.uploadPhoto': 'Upload Photo/Video'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/profile.js